/**
 * ImportProgressStep — chunked-upload progress. No back/cancel while
 * in flight; the wizard hides its footer during this step.
 */

import { ProgressBar } from '@/components/ui/progress';

export interface ImportProgress {
  chunksDone: number;
  chunksTotal: number;
  created: number;
  skipped: number;
  failed: Array<{ rowIndex: number; error: string }>;
}

interface Props {
  progress: ImportProgress;
}

export function ImportProgressStep({ progress }: Props) {
  const percent =
    progress.chunksTotal === 0 ? 100 : (progress.chunksDone / progress.chunksTotal) * 100;
  return (
    <div className="flex flex-col items-center gap-4 py-8">
      <p className="text-sm font-medium">Importing… don't close this page</p>
      <ProgressBar value={percent} className="max-w-md" />
      <p className="text-xs text-muted-foreground">
        {progress.created.toLocaleString()} imported · {progress.skipped.toLocaleString()} skipped ·{' '}
        {progress.failed.length.toLocaleString()} failed
      </p>
    </div>
  );
}
